import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app/store';

export enum UploadSortOrderEnum {
  newest = 'newest',
  percentComplete = 'percentComplete',
}

export interface ScansState {
  searchValue: string;
  uploadSortOrder: UploadSortOrderEnum;
  scansCustomerID: string;
  scansRanchID: string;
  scansBlockID: string;
}

const initialState: ScansState = {
  searchValue: '',
  uploadSortOrder: UploadSortOrderEnum.newest,
  scansCustomerID: '',
  scansRanchID: '',
  scansBlockID: '',
};

export const ScansStateSlice = createSlice({
  name: 'scansState',
  initialState,
  reducers: {
    initScansState: () => initialState,
    setSearchValue: (state, action: PayloadAction<{ newValue: string }>) => {
      state.searchValue = action.payload.newValue;
    },
    setUploadSortOrder: (state, action: PayloadAction<UploadSortOrderEnum>) => {
      state.uploadSortOrder = action.payload;
    },
    setScansCustomerID: (state, action: PayloadAction<string>) => {
      state.scansCustomerID = action.payload;
    },
    setScansRanchID: (state, action: PayloadAction<string>) => {
      state.scansRanchID = action.payload;
    },
    setScansBlockID: (state, action: PayloadAction<string>) => {
      state.scansBlockID = action.payload;
    },
  },
});

export const {
  initScansState,
  setSearchValue,
  setUploadSortOrder,
  setScansCustomerID,
  setScansRanchID,
  setScansBlockID,
} = ScansStateSlice.actions;

export const selectSearchValue = (state: RootState) => state.scans.searchValue;
export const selectUploadSortOrder = (state: RootState) =>
  state.scans.uploadSortOrder;
export const selectScansCustomerID = (state: RootState) =>
  state.scans.scansCustomerID;
export const selectScansRanchID = (state: RootState) =>
  state.scans.scansRanchID;
export const selectScansBlockID = (state: RootState) =>
  state.scans.scansBlockID;

export default ScansStateSlice.reducer;
